<template>
<!-- 慕课 -->
    <div class="mooc_warp">
        <div class="contanner mooc_list">
            <div class="mooc_list_item" @click="toDetail(item)" v-for="item in moocList" :key="item.id">
                <el-image class="item_img" :src="item.coverUrl"></el-image>
                <div class="item_status">已更新1期</div>
                <div class="item_info">
                    <div class="info_title ellipsis">{{item.title}}</div>
                    <div class="itme_date"> 最近更新：{{item.updateTime}} </div>
                </div>
            </div>
        </div>
         <Pagination
            :total="total"
            :page.sync="currentPage"
            :limit.sync="pageSize"
            @pagination="handleCurrentChange"
        />
    </div>
</template>

<script>    
import Pagination from '@c/Pagination';
import { post } from '@u/request';
export default {
    name: '',
    components: {
        Pagination
    },
    data() {
        return {
            total: 0,
            currentPage: 1,
            pageSize: 10,
            moocList: []
        }
    },
  
    methods: {
        toDetail(item) {
            this.$router.push(`/mooc/detail/${item.id}`)
        },

        handleCurrentChange() {
            this.loadMooc()
        },
        async loadMooc() {
            const params = {
                pid: this.$route.query.id,
                venueIds: this.$store.getters.venueId,
                page: this.currentPage,
                limit: this.pageSize
            }
            const { data, count } = await post('resource/offlinesource/list', params);
            this.moocList = data;
            this.total= count;
        }
    },
    mounted() {
        this.loadMooc()
    }
}
</script>

<style scoped lang="scss">
.mooc_warp {
    background: #f8f8f8;
    padding-bottom: 20px;
    min-height: calc(100vh - 315px);
    .mooc_list {
        padding-top: 20px;
        display: flex;
        flex-wrap: wrap;
    }
    .mooc_list_item {
            width: 386px;
            margin: 0 20px 20px 0;
            background: #fff;
            box-shadow: 0 10px 18px 0 rgba(0,0,0,.05);
            border-radius: 5px;
            cursor: pointer;
            overflow: hidden;
            position: relative;
            &:nth-child(3n) {
                margin-right: 0;
            }
            .item_img {
                width: 100%;
                height: 180px;
                object-fit: cover;
                ::v-deep .el-image__inner {
                    object-fit: cover; 
                }
            }
            .item_status {
                position: absolute;
                top: 18px;
                left: 18px;
                width: 85px;
                height: 23px;
                line-height: 23px;
                border-radius: 23px 23px 23px 0;
                font-weight: 400;
                text-align: center;
                color: #fff;
                font-size: 14px;
                background: #07bb3f;
            }
            .item_info {
                padding: 18px;
                font-size: 14px;
                line-height: 1;
            }
            .info_title {
                font-size: 18px;
                color: #000;
                padding-bottom: 18px;
            }
            .itme_date {
                color: #2f7ef7;
                padding-bottom: 15px;
            }
        }
}
</style>